import { render, staticRenderFns } from "./DevPageKA1.vue?vue&type=template&id=798ac688&scoped=true"
import script from "./DevPageKA1.vue?vue&type=script&lang=js"
export * from "./DevPageKA1.vue?vue&type=script&lang=js"
import style0 from "./DevPageKA1.vue?vue&type=style&index=0&id=798ac688&prod&lang=css"
import style1 from "./DevPageKA1.vue?vue&type=style&index=1&id=798ac688&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "798ac688",
  null
  
)

export default component.exports